import { AdvisorInformation } from "src/app/models/entity";
import { IInvestorEntityDetails } from "src/app/models/investor";

export interface IInvestorUpdateStatus {
    isLoading: boolean;
    updateFail: boolean;
    updateSuccess: boolean;
}

export interface IInvestorState {
    details: IInvestorEntityDetails;
    investorUpdateStatus: IInvestorUpdateStatus;
    advisorInformation: AdvisorInformation[]
}

export const initialInvestorState: IInvestorState = {
    details: {
        bankAccount: null,
        taxDetails: {
            countryTaxResidency: 'New Zealand',
            marginalTaxRate: -1,
            taxRate: '',
            irdNumber: '',
            taxResidentOverseas: false,
            foreignTaxResidences: null,
            rwtExempt: false,
            ail: false
        },
        investorDetails: {
            investorEntityId: null,
            legalEntityType: null,
            name: '',
            addresses: null,
            reinvestmentOption: '',
            subType: null,
            investorStatus: null
        }
    },
    investorUpdateStatus: {
        isLoading: false,
        updateFail: false,
        updateSuccess: false
    },
    advisorInformation : []
};